import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/shared/model/user.model';
import { CentersES } from 'src/app/shared/model/es.model';
import { Observable } from 'rxjs';
import { ESResponse } from 'src/app/shared/model/request-list.model';

@Injectable({
  providedIn: 'root'
})
export class EsService {
  urlEs =
    environment.env === 'dev'
      ? 'https://' + `${environment.API_CONTEXT}/es-service`
      : `${environment.API_CONTEXT}/es-service`;

  constructor(private http: HttpClient) {}

  getCenters() {
    return this.http.get<CentersES[]>(`${this.urlEs}/hubs`);
  }

  getExternalDrivers(fullNameLike: string) {
    const params = new HttpParams().set('fullNameLike', fullNameLike);
    return this.http.get<User[]>(`${this.urlEs}/external-drivers`, {
      params: params
    });
  }

  createOrUpdateDriver(
    company: string,
    departmentCode: string,
    email: string,
    fullName: string,
    identificationDocument: string,
    address: string,
    phoneNumber: string,
    driverLicenseDocument: string,
    id?: string
  ) {
    const body = {
      company,
      departmentCode,
      email,
      fullName,
      identificationDocument,
      address,
      phoneNumber,
      driverLicenseDocument
    };
    return id
      ? this.http.put(`${this.urlEs}/external-drivers/` + id, body)
      : this.http.post(`${this.urlEs}/external-drivers`, body);
  }

  getExternalDriver(id: string) {
    return this.http.get<User>(`${this.urlEs}/external-drivers/${id}`);
  }

  createES(body: any) {
    return this.http.post(`${this.urlEs}/es`, body);
  }

  getESList(page: number): Observable<ESResponse> {
    const params = new HttpParams().set('page', page);
    const headers = new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      'Content-Type': 'application/json; charset=utf-8'
    });
    return this.http.get<ESResponse>(`${this.urlEs}/es`, {
      params: params,
      headers
    });
  }

  getESByAuthorizationId(authorizationId: string): Observable<any> {
    return this.http.get<any>(`${this.urlEs}/es/${authorizationId}`);
  }
}
